const css = `.fsw7ia__inline{display:inline}.fsw7ia__inline-block{display:inline-block}.fsw7ia__flex{display:flex}.fsw7ia__block{display:block}.fsw7ia__grid{display:grid}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"block":"fsw7ia__block","inline-block":"fsw7ia__inline-block","inline":"fsw7ia__inline","flex":"fsw7ia__flex","grid":"fsw7ia__grid"};
